import { Link } from "react-router-dom";
import { ChevronRight, Star } from "lucide-react";
import { initials, tone } from "@/lib/toto";

export function Avatar({ name, size = 48 }) {
  const [bg, fg] = tone(name || "");
  return (
    <span className="rounded-full flex items-center justify-center font-bold shrink-0" style={{ width: size, height: size, background: bg, color: fg, fontSize: size * 0.36 }}>
      {initials(name)}
    </span>
  );
}

export default function ContactRow({ contact, right }) {
  const sub = [contact.designation, contact.companyName].filter(Boolean).join(" · ");
  return (
    <div className="t-card min-w-0 flex items-center gap-3 p-3.5 pr-3 transition-[box-shadow,transform] duration-150 hover:shadow-[0_6px_20px_-12px_rgba(15,23,42,.25)]" data-testid={`contact-row-${contact.id}`}>
      <Link to={`/contacts/${contact.id}`} className="flex items-center gap-3 flex-1 min-w-0">
        <Avatar name={contact.name || contact.companyName} />
        <span className="flex-1 min-w-0">
          <span className="flex items-center gap-1.5">
            <span className="text-[17px] font-bold truncate">{contact.name || contact.companyName || "Unnamed"}</span>
            {contact.isFavorite && <Star className="w-4 h-4 fill-[#D97706] text-[#D97706] shrink-0" />}
          </span>
          {sub && <span className="block text-[14px] text-[#64748B] truncate">{sub}</span>}
        </span>
        {!right && <ChevronRight className="w-5 h-5 text-[#475569]" />}
      </Link>
      {right}
    </div>
  );
}
